import React from 'react'
import { observer } from 'mobx-react'

import Typography from '../../../../../UniformComponents/Typography'
import BubbleLoader from '../../../../../UniformComponents/BubbleLoader'

const AiOverview = ({ store, summary }) => {
    const { generatingSummary } = store
    console.log('GEN', store)
    return process.env.SHOW_AI_ASSISTANT ? (
        <div id="aiOverview">
            <div className="container" style={{ width: '100%' }}>
                <div className="icon-container">
                    <i className="fas fa-sparkles" />
                </div>

                {generatingSummary ? (
                    <div className="generating-container">
                        <BubbleLoader />
                    </div>
                ) : (
                    <Typography>
                        {summary}
                    </Typography>
                )}
            </div>
        </div>
    ) : null
}

export default observer(AiOverview)
